import React from "react";

import { SeasonMapMusic } from "lib/types";
import { AudioProvider } from "sharedComponents/contexts/audio";

import NewInTownMP3 from "./resource/new_in_town.mp3";
import NewInTownWebM from "./resource/new_in_town.webm";
import spriteData from "./resource/output.json";
import spriteMP3 from "./resource/output.mp3";
import spriteWebM from "./resource/output.webm";

const backgroundClips = {
  [SeasonMapMusic.NewInTown]: [
    { src: NewInTownWebM, type: "audio/webm" },
    { src: NewInTownMP3, type: "audio/mpeg" },
  ],
};

const SEASON_MAP_VOLUME_KEY = "SEASON_MAP_VOLUME";

export const Season2MapAudio: React.FC = ({ children }) => {
  return (
    <AudioProvider
      backgroundClips={backgroundClips}
      srcVolume={1}
      spriteSrc={[spriteWebM, spriteMP3]}
      sprite={spriteData.sprite}
      volumeStorageKey={SEASON_MAP_VOLUME_KEY}
    >
      {children}
    </AudioProvider>
  );
};
